import fetch from '@/utils/fetch';
import axios from 'axios';

//  商户资产信息查询
export function accountView(data = {}) {
  return fetch({
    url: `/saas/order/m/s/hfpay/account/view`,
    method: 'post',
    data,
  });
}

//  商户汇付余额
export function hfAccountAssetsView(data = {}) {
  return fetch({
    url: `/saas/order/m/s/hfpay/account/asset/view`,
    method: 'post',
    data,
  });
}

//  商户提现
export function hfpayWithdraw(data = {}) {
  return fetch({
    url: `/saas/order/m/s/hfpay/cash`,
    method: 'post',
    data,
  });
}
//  提现记录
export function adapayCashList(data = {}) {
  return fetch({
    url: `/saas/order/m/s/adapay/draw/cash/list`,
    method: 'post',
    data,
  });
}

/**
 * 银行列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function bankList(data = {}) {
  return fetch({
    url: '/saas/user/m/s/hfpay/bank/list',
    method: 'post',
    data,
  });
}

/**
 * 省列表
 *
 * @export
 * @param {any} data
 * @returns
 */
export function provinceList(data = {}) {
  return fetch({
    url: '/saas/user/m/s/hfpay/province/list',
    method: 'post',
    data,
  });
}

export function cityList(data = {}) {
  return fetch({
    url: '/saas/user/m/s/hfpay/city/list',
    method: 'post',
    data,
  });
}

export function accountCreate(data = {}) {
  return fetch({
    url: '/saas/order/m/s/adapay/account/create',
    method: 'post',
    data,
  });
}
export function accountUpdate(data = {}) {
  return fetch({
    url: '/saas/order/m/s/adapay/account/update',
    method: 'post',
    data,
  });
}

//个人开户信息查询
export function getAccountView(data = {}) {
  return fetch({
    url: '/saas/order/m/s/adapay/account/view',
    method: 'post',
    data,
  });
}

//  个人提现
export function personaldrawcash(data = {}) {
  return fetch({
    url: `/saas/order/m/s/adapay/draw/cash`,
    method: 'post',
    data,
  });
}


//  礼物记录
export function giftList(data = {}) {
  return fetch({
    url: `/saas/order/m/s/gift/shop/list`,
    method: 'post',
    data,
  });
}

//公共接口查看七牛返回文件信息
export function getQiniuInfos(url, data = {}) {
  return axios.get(url, data)
}
